import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ModalComponent } from '@app/ui-components/modal/modal.component';
import { ValidatedCheckboxComponent } from '@app/ui-components/validated-checkbox/validated-checkbox.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ExpDeteminationFormGroup,
  getExpDeteminationFormGroup,
} from './exp-detemination-dialog.helper';

@Component({
  selector: 'app-exp-determination-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    ReactiveFormsModule,
    ModalComponent,
    ValidatedCheckboxComponent,
  ],
  templateUrl: './exp-determination-dialog.component.html',
  styleUrl: './exp-determination-dialog.component.scss',
})
export class ExpDeterminationDialogComponent {
  protected expDeterminationForm: FormGroup<ExpDeteminationFormGroup>;
  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {
    this.expDeterminationForm = getExpDeteminationFormGroup(fb);
  }

  protected handlePrimaryAction() {
    this.expDeterminationForm.markAllAsTouched();
    if (!this.expDeterminationForm.valid) return;

    this.activeModal.close(this.expDeterminationForm.value);
  }

  protected handleSecondaryAction() {
    this.activeModal.dismiss('canceled');
  }
}
